module.exports = __webpack_public_path__ + "static/media/hackthebox.547c1edd.png";